import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCalendarIconSecondary from './svgs/CalendarIconSecondary.js';
import SvgCalendarIcon from './svgs/CalendarIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var calendarIcon = (props => useIcon(SvgCalendarIcon, SvgCalendarIconSecondary, props));

export { calendarIcon as default };
